module.exports = __webpack_public_path__ + "img/hotel-3.f599b56c.jpeg";